import Parse from "parse";

import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useGame } from "../header/GameContext";
import { CHAT_DATA } from "./chatData";

import Header from "../header/header";

import "./chat.css";

import box_icon2 from "../../img/game/box_icon2.png";
import img_cone from "../../img/game/img_cone-big.png";

function ChatBox({ onFinish, defaultPath, viewHeader = true }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { DB_TABLE, playerName, increaseMissionOnce, interpolate, initStage1 } =
    useGame();

  const state = location.state || {};
  const { DateVal, titImgClass } = state;

  // useEffect(() => {
  //   setIdx(0);
  //   setVisible([]);
  //   setActiveButton(null);
  // }, [DateVal]);

  useEffect(() => {
    if (location.pathname === "/story2") {
      initStage1();
    }
  }, []);

  useEffect(() => {
    const saveStage = async () => {
      if (
        DateVal === "stage1" ||
        DateVal === "stage2" ||
        DateVal === "stage3" ||
        DateVal === "write_dream" ||
        DateVal === "take_picture"
      ) {
        try {
          const GameUser = Parse.Object.extend(DB_TABLE);
          const query = new Parse.Query(GameUser);
          const objectId = localStorage.getItem("gameUserId");
          const user = await query.get(objectId);

          user.addUnique("access_stage", DateVal);
          await user.save();
        } catch (error) {
          console.error("에러 코드:", error.code);
          console.error("에러 메시지:", error.message);
        }
      }
    };

    saveStage();
  }, [DateVal]);

  /* =========================
     데이터
  ========================= */
  const replaceVariables = {
    playerName,
    box_icon2,
    img_cone,
  };

  const rawContents = Array.isArray(DateVal) ? DateVal : CHAT_DATA[DateVal];

  const contents = rawContents.map((item) => ({
    ...item,
    text: interpolate(item.text, replaceVariables),
  }));

  /* =========================
     상태
  ========================= */
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState([]);
  const [activeButton, setActiveButton] = useState(null);

  const chatBoxRef = useRef(null);

  /* =========================
     스크롤
  ========================= */
  const scrollToBottom = () => {
    if (!chatBoxRef.current) return;
    chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
  };

  const scrollWindowToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  /* =========================
     채팅 출력 로직
  ========================= */
  useEffect(() => {
    if (idx >= contents.length) {
      scrollWindowToBottom(); // ✅ 모든 채팅 렌더링 완료
      return;
    }

    const item = contents[idx];

    /* scroll 타입 */
    if (item.type === "scroll") {
      setIdx((prev) => prev + 1);
      requestAnimationFrame(scrollToBottom);
      return;
    }

    /* button 타입 */
    if (item.type === "button") {
      setActiveButton(item);
      scrollWindowToBottom(); // ✅ 버튼이 마지막인 경우
      requestAnimationFrame(scrollToBottom);
      return;
    }

    /* 일반 채팅 */
    const t = setTimeout(() => {
      setVisible((prev) => [...prev, item]);
      setIdx((prev) => prev + 1);
    }, 1000);

    return () => clearTimeout(t);
  }, [idx]);

  /* =========================
     메시지 추가될 때 스크롤
  ========================= */
  useEffect(() => {
    requestAnimationFrame(scrollToBottom);
  }, [visible]);

  /* =========================
     버튼 클릭
  ========================= */
  const onBtnClick = () => {
    if (!activeButton) return;

    const { action, route, state } = activeButton;

    setActiveButton(null);
    setIdx((prev) => prev + 1);

    const actionMap = {
      finish: () =>
        onFinish?.({
          route,
          defaultPath,
          state,
        }),

      route: () =>
        onFinish?.({
          route,
          defaultPath,
          state,
        }),

      url: () => window.open(activeButton.url, "_blank"),
    };

    actionMap[action]?.();
  };

  return (
    <div className="box content_box1">
      {viewHeader && <Header />}

      <div
        className={`box_con con_box1 ans0001 ${
          viewHeader ? "con_pd5" : "con_pd4"
        }`}
      >
        {titImgClass && <div className={`mission_tit ${titImgClass}`} />}

        {/* 채팅 영역 */}
        <div
          className={`${
            !viewHeader ? "chat_box8" : titImgClass ? "chat_box2" : "chat_box3"
          } mt24`}
          ref={chatBoxRef}
          style={{ overflowY: "auto" }}
        >
          {visible.map((c, i) => {
            if (c.type === "chatInfo_Talk1") {
              return (
                <div
                  key={i}
                  className={`chatInfo_Talk ${c.marType || ""}`}
                  dangerouslySetInnerHTML={{ __html: c.text }}
                />
              );
            }

            if (c.type === "leftCharacter") {
              return (
                <div key={i} className={`chat_b_left ${c.marType || ""}`}>
                  <div className="chat_b_l_left mr8">
                    <span className={c.chat_icon} />
                  </div>
                  <div className="chat_b_l_right">
                    <p className="chat_tit mb4">
                      {interpolate(c.chat_tit, { playerName })}
                    </p>
                    <div
                      className={c.talkType}
                      dangerouslySetInnerHTML={{ __html: c.text }}
                    />
                  </div>
                </div>
              );
            }

            if (c.type === "left_txt") {
              return (
                <div key={i} className={`chat_b_left ${c.marType || ""}`}>
                  <div className="chat_b_l_left mr8" />
                  <div className="chat_b_l_right">
                    <div
                      className={c.talkType}
                      dangerouslySetInnerHTML={{ __html: c.text }}
                    />
                  </div>
                </div>
              );
            }

            if (c.type === "rightCharacter") {
              return (
                <div key={i} className={`chat_b_right ${c.marType || ""}`}>
                  <div className="chat_b_r_left mr8">
                    <p className="chat_tit mb4">
                      {interpolate(c.chat_tit, { playerName })}
                    </p>
                    <div
                      className={c.talkType}
                      dangerouslySetInnerHTML={{ __html: c.text }}
                    />
                  </div>
                  <div className="chat_b_r_right">
                    <span className={c.chat_icon} />
                  </div>
                </div>
              );
            }

            if (c.type === "right_txt") {
              return (
                <div key={i} className={`chat_b_right ${c.marType || ""}`}>
                  <div className="chat_b_r_left mr8" />
                  <div className="chat_b_r_right">
                    <div
                      className={c.talkType}
                      dangerouslySetInnerHTML={{ __html: c.text }}
                    />
                  </div>
                </div>
              );
            }

            if (c.type === "ImgOnly") {
              return (
                <div key={i} className={c.marType || ""}>
                  <img
                    src={c.src}
                    className={c.className}
                    alt=""
                    onLoad={scrollToBottom} // ✅ 이미지 로드 완료 후 스크롤
                  />
                </div>
              );
            }

            return null;
          })}
        </div>

        {/* 버튼 */}
        {activeButton && (
          <div className="chat_btn_area mt24">
            <button className="inputBtn02" onClick={onBtnClick}>
              {activeButton.label}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ChatBox;
